const Tooltip = {
  baseStyle: {
    bg: "brand.600",
    color: "white"
  }
};

export default Tooltip;
